/**
 * Shared UI text rules.
 *
 * No em dash (—) in any user-facing text: it reads as machine-written. Use a
 * colon, full stop, comma, "·" or "to" instead, chosen for the sentence.
 * The guard test (uiNoEmDash.test.ts) fails on new ones.
 */

/** Placeholder for an unknown or missing value in a cell or label (en dash, not em dash). */
export const UNKNOWN_CELL = '–';
